/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 36).
 */
import * as React from 'react';
import Field from './Field';
import Label from './Label';
import Details from './Details';
import { LABEL_TYPES, LabelType } from './LABEL_TYPESConstants';

export interface SelectOption {
  text: string;
  value: string;
}

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'id' | 'value' | 'className'> {
  /** A unique identifier - will also be used as name property for input */
  id: string;
  /** Current value of the input.  Should not be initialized before user interacts with input */
  value?: string | null;
  /** Use 'aria' for an aria-label only or 'visible' for a visible <label> element */
  labelType?: LabelType;
  /** Text value used in aria-label or label element depending on labelType */
  label: string;
  /**
   * Placeholder used before user makes a selection.  Should be short and provide information
   * about what type of options to expect.  Example: Select a topping
   */
  placeholder?: string;
  /** Optional text to display below the input to provide additional clarification or guidance */
  helperText?: string | null;
  /**
   * Options to include in the dropdown.  Must be an array of objects, and each object must have
   * a value and a text property
   */
  options: SelectOption[];
  /** Disables input and grays it out */
  disabled?: boolean;
  /** Adds red styling to show that value is invalid */
  invalid?: boolean;
  /** Optional text to provide information about why input is invalid */
  errorMessage?: string;
  /** String of additional class names to add; can be useful for setting the size of the element */
  className?: string | null;
  /** Optional flag to hide help text when there is an error */
  suppressHelpTextOnError?: boolean;
}

const renderOptions = (options: SelectOption[]) =>
  options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.text}
    </option>
  ));

const Select = ({
  id,
  value = null,
  labelType = LABEL_TYPES.VISIBLE,
  label,
  placeholder = '',
  helperText = null,
  options,
  disabled = false,
  invalid = false,
  errorMessage = 'Please select an option',
  className = null,
  suppressHelpTextOnError = false,
  ...rest
}: SelectProps) => {
  const placeholderText = placeholder && `\u2014 ${placeholder} \u2014`;

  return (
    <Field invalid={invalid} disabled={disabled} className={className}>
      <Label labelType={labelType} id={id} label={label} />
      <div className="Select">
        <select
          {...rest}
          id={id}
          value={value || ''}
          disabled={disabled}
          aria-label={labelType === LABEL_TYPES.VISIBLE ? undefined : label}
          aria-labelledby={labelType === LABEL_TYPES.VISIBLE ? `labelFor-${id}` : undefined}
          aria-describedby={helperText ? `${id}-detail` : undefined}
        >
          <option disabled value="">
            {placeholderText}
          </option>
          {renderOptions(options)}
        </select>
      </div>
      <Details
        errorMessage={errorMessage}
        helperText={helperText}
        id={id}
        invalid={invalid}
        suppressHelpTextOnError={suppressHelpTextOnError}
      />
    </Field>
  );
};

export default Select;


